import { render, staticRenderFns } from "./Change_l.vue?vue&type=template&id=625f9d6d&scoped=true"
import script from "./Change_l.vue?vue&type=script&lang=js"
export * from "./Change_l.vue?vue&type=script&lang=js"
import style0 from "./Change_l.vue?vue&type=style&index=0&id=625f9d6d&prod&lang=css"
import style1 from "./Change_l.vue?vue&type=style&index=1&id=625f9d6d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f9d6d",
  null
  
)

export default component.exports